document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("prelaunch-form");
  const emailInput = document.getElementById("email");
  const submitButton = document.getElementById("verre-submit");
  const message = document.getElementById("verre-form-message");

  if (!form || !emailInput || !submitButton || !message) {
    return;
  }

  form.addEventListener("submit", async function (event) {
    event.preventDefault();

    const email = emailInput.value.trim();

    if (!email) {
      message.textContent = "Please enter your email address.";
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = "ENTERING...";

    try {
      const response = await fetch("https://a.klaviyo.com/client/subscriptions/?company_id=SZjnQS", {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.api+json",
          "revision": "2025-10-15"
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email
                  }
                }
              },
              custom_source: "VERRE Gallery — The Atelier"
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: "T5gMVZ"
                }
              }
            }
          }
        })
      });

      if (!response.ok) {
        throw new Error("Klaviyo subscription failed");
      }

      message.textContent = "Your invitation to THE ATELIER PRIVATE CIRCLE has been accepted.";
      form.reset();
    } catch (error) {
      message.textContent = "Something went wrong. Please try again.";
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = "ENTER THE ATELIER PRIVATE CIRCLE";
    }
  });
});